import React from 'react';
import { CheckCircle, ExternalLink } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { certificatesData } from '../mock';

const Certificates = () => {
  const handleCertificateClick = (pdfUrl) => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Sertifikatlar və Təsdiqnamələr
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Beynəlxalq standartlara uyğun işləyirik
          </p>
        </div>

        {/* Certificates Grid */}
        <div className="flex justify-center items-center">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-8 max-w-3xl">
            {certificatesData.map((certificate, index) => (
              <Card
                key={certificate.id}
                className={`group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-green-100 hover:border-green-400 bg-white ${certificate.pdfUrl ? 'cursor-pointer' : ''}`}
                style={{
                  animationDelay: `${index * 100}ms`
                }}
                onClick={() => handleCertificateClick(certificate.pdfUrl)}
              >
                <CardHeader>
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-400 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      <CheckCircle className="text-white" size={32} />
                    </div>
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900 text-center group-hover:text-green-600 transition-colors duration-200">
                    {certificate.name}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 text-center mb-4">
                    {certificate.description}
                  </CardDescription>
                  {certificate.pdfUrl && (
                    <div className="flex justify-center">
                      <span className="inline-flex items-center text-green-600 hover:text-green-700 font-medium text-sm">
                        Sertifikatı göstər
                        <ExternalLink className="ml-1" size={16} />
                      </span>
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certificates;
